import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans- serif',
        fontSize: '14px',
        lineHeight: '1.5'
    },
    margin: {
        margin: theme.spacing(1)
    },
    header: {
        backgroundColor: '#3399cc',
        padding: '20px'
    },
    textInfo: {
        color: '#31708f'
    },
    textCenter: {
        textAlign: "center"
    }
}));

export default function ReleaseNotes() {
    const classes = useStyles(); 

    return (
        <Container className={classes.root}>
            <div className={classes.header}>
                <h1>TeamLEAD Release Notes</h1>
            </div>
            <Container maxWidth="xl">
                <hr />
                <h2>TeamLEAD June 21st 2017 Release</h2>
                <ul className={classes.textInfo}>
                    <li>Coach: When coach entered through round location it is displayed but not selected</li>
                    <li>Screen: resize screen when device moved from vertical to horizontal</li>
                    <li>All Modules: When touch date control and select date, user must touch another control to get date control again</li>
                    <li>Reports: Round Report shows results for different values then the filters show</li>
                    <li>Reports: Create new HTML report for Journal</li>
                    <li>Geography Groups: Add Filter to Geography Locations for Geography Names</li>
                    <li>Geography Groups: When adding locations to Geography Groups remove inactive locations</li>
                    <li>Geography Groups: Allow to show more values when displaying Geography Locations</li>
                    <li>Patient Visitation Log: Edits are not being saved for Visitation Logs</li>
                    <li>Coach: Change Date format on Queue to MM/DD/YYYY HH:MM  AM/PM</li>
                    <li>TeamLead: Application does not time out on IPad or IPhone</li>
                    <li>Coach Framework: Update the ii Framework and .Net Framework 2.0 to 4.5</li>
                    <li>Security: Change windows authentication to form authentication and authenticate with Active Directory</li>
                    <li>Login: When logging out or timed out, redirect to new login page</li>
                    <li>Service Recovery: Added through Patient Visitation the Service Recovery already contains data, separate by Patient</li>
                    <li>Coach: List should not cause keyboard to pop up</li>
                    <li>Login: Page is not centered on IPad when vertical</li>
                    <li>Offline: Concurrency issue for all modules should update by Modified Date when Synchronization</li>
                    <li>Epay: Add new tile for Epay Punch Information</li>
                    <li>Reports: Journal report filters and export to Excel do not work</li>
                    <li>Home Page: When IPad turned horizontal the tiles do not display correctly </li>
                    <li>Login: Release Note link not showing and both Release Note </li>
                </ul>
                <hr />
                <h2>TeamLEAD August 16th 2017 Release</h2>
                <ul className={classes.textInfo}>
                    <li>Next Release</li>
                </ul>
                <hr />
                <div className={classes.textCenter}>
                    <h6 style={{ textTransform: "none" }}>Copyright &copy;2005-2017 Compass Group NAD. All rights reserved.</h6>
                    <h6 style={{ textTransform: "none" }}>SECURITY DISCLAIMER This Computer system is for authorized users only. Individuals using this computer system without authority, or in excess of their authority, are subject to having all their activities on this system monitored and recorded by system personnel. If necessary appropriate action will be taken against individuals when misuse, and/or unauthorized use is detected. These actions could result in counseling, suspension or employment termination depending upon severity. Anyone using this system expressly consents to such monitoring and is advised that if such monitoring reveals possible evidence of criminal activity, system personnel may provide the evidence of such monitoring to law enforcement officials.</h6>
                    <h6 style={{ textTransform: "none" }}>*** Highly Confidential Protected Data. For Limited Internal Use only by Authorized Personnel ***</h6>
                    <h6 style={{ textTransform: "none" }}>*** Not for External Release or Review/Discussion with Unauthorized Personnel ***</h6>
                </div>
            </Container>
        </Container>
    );
}
